'use client';

import { c as _c } from "react/compiler-runtime";
import { Popover } from '@base-ui/react/popover';
import { preload } from 'react-dom';
import { Card } from '@/components/Card';
import { CardActionTitleBar } from '@/components/CardActionTitleBar';
import { CloseIcon } from '@/components/icons/CloseIcon';
import type { SiteSlugType } from '@/lib/preferredSite';
import { VisualSiteLink } from './VisualSiteLink';
import australiaPic from './australia-image.jpg';
import newZealandPic from './new-zealand-image.jpg';
export interface VisualSiteSelectorProps {
  siteSlug?: string;
  localeSlug: string;
  onClickAction?: (siteSlug: SiteSlugType) => void;
}
export function VisualSiteSelector(t0) {
  const $ = _c(13);
  const {
    siteSlug,
    localeSlug,
    onClickAction
  } = t0;
  preload(australiaPic.src, {
    as: "image"
  });
  preload(newZealandPic.src, {
    as: "image"
  });
  let t1;
  if ($[0] !== onClickAction || $[1] !== siteSlug) {
    t1 = () => onClickAction?.(siteSlug as SiteSlugType);
    $[0] = onClickAction;
    $[1] = siteSlug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <sup><CloseIcon className="text-base" /></sup>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1) {
    t3 = <CardActionTitleBar className="px-4" rightAction={<Popover.Close className="outline-none focus:outline-none cursor-pointer" onClick={t1}>{t2}</Popover.Close>}>Pick a destination!</CardActionTitleBar>;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Popover.Description className="text-xs text-gray-600"><span className="inline lg:hidden">Change your travel destination in the top right</span><span className="hidden lg:inline">Change your travel destination here</span></Popover.Description>;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== localeSlug || $[8] !== onClickAction) {
    t5 = <div className="grid grid-cols-2 grid-rows-1 gap-4"><VisualSiteLink siteSlug="au" localeSlug={localeSlug} imgSrc={australiaPic.src} onClickAction={onClickAction} /><VisualSiteLink siteSlug="nz" localeSlug={localeSlug} imgSrc={newZealandPic.src} onClickAction={onClickAction} /></div>;
    $[7] = localeSlug;
    $[8] = onClickAction;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t3 || $[11] !== t5) {
    t6 = <Card className="w-full h-full max-w-[344px] max-h-[162px] [&_.card-body]:pt-2 [&_.card-body]:pb-4 [&_.card-body]:px-4" titleBar={t3}>{t4}{t5}</Card>;
    $[10] = t3;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}